<div class="robot">
  <div class="robot-face" #robotFace>
    <div class="eyebrow left-brow"></div>
    <div class="eyebrow right-brow"></div>
    <div class="eye"></div>
    <div class="eye"></div>
  </div>
</div>
